var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLupa({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.891,
    height: 23.614,
    viewBox: "0 0 21.891 23.614",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:none;stroke:#173c6d;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15934",
    transform: "translate(-880.97 -522.14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15192",
    fill: "#f26d6d",
    d: "M891.493 533.32a6.818 6.818 0 0 1-7.043-6.585 6.737 6.737 0 0 1 .875-3.523 6.8 6.8 0 1 0 9.246 9.222 6.722 6.722 0 0 1-3.078.886z",
    transform: "translate(0 .674)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "L\\xEDnea_521",
    d: "M8.436 9.309L0 0",
    className: "cls-2",
    transform: "translate(893.012 535.031)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_768",
    cx: 6.839,
    cy: 6.839,
    r: 6.839,
    fill: "#fff",
    stroke: "#173c6d",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "2px",
    transform: "translate(881.97 523.14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15193",
    d: "M883.2 525.742a3.671 3.671 0 0 1 5.07-1.122",
    className: "cls-2",
    transform: "translate(2.278 2.031)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLupa);
export default __webpack_public_path__ + "static/media/lupa.53fd5537e3257601df5ff48e00ceaad3.svg";
export { ForwardRef as ReactComponent };